import type { CountryLanguages } from '~/types/countryLanguages';
import type { SectionId } from '~/types/sectionId';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { buildLocalizedPath } from '~/utils/buildLocalizedPath';
import { findSectionConfigById } from '~/utils/findSectionConfigById';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function resolveSectionSwitchPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    sectionId: SectionId | null | undefined,
    country: string,
    language: string,
    countryLanguages: CountryLanguages
): string {
    const targetConfig = sectionId ? findSectionConfigById(registry, country, sectionId) : null;
    const targetSectionPath = targetConfig ? resolveSectionPath(targetConfig, language, countryLanguages) : null;

    return buildLocalizedPath(country, language, targetSectionPath ?? '');
}
